import {useTranslation} from 'react-i18next';
import * as css from '../menu.css';
import {DeliveryTypeMenuProps} from '../types';
import {bounceMessage} from '../../../../layout/userMessages/UserMessage';

type DeliveryType = string;

function renderMenuItem(
    dType: DeliveryType,
    bIcon: string | JSX.Element,
    selectedDeliveryType: string,
    onSelect: (type: string) => void,
    t: (key: string) => string,
    disabledDeliveryTypes: ('email' | 'sms' | 'whatsapp')[] = []
) {

    const isDisabled = disabledDeliveryTypes.includes(dType as 'email' | 'sms' | 'whatsapp');
    const handleClick = () => {
        if(isDisabled) {
            bounceMessage(
                t('whatsappDisabledMessage'),
                'attention',
            );
            return;
        }
        onSelect(dType);
    };
    
    return (
        <css.MenuItem
            key={dType}
            $icon={typeof bIcon === 'string' ? bIcon : undefined}
            $selected={dType === selectedDeliveryType}
            $disabled={isDisabled}
            onClick={handleClick}
            role="menuItem"
            aria-selected={dType === selectedDeliveryType}
            aria-disabled={isDisabled}
        >
            {typeof bIcon === 'string' ? null : bIcon}
            <css.MenuText>{t(dType)}</css.MenuText>
            <css.EmailIcon />
        </css.MenuItem>
    );
}

function DeliveryTypeMenu({
    isVisible,
    isMobile,
    deliveryTypeIcons,
    selectedDeliveryType,
    onSelect,
    allowedDeliveryTypes,
    disabledDeliveryTypes = []
}: DeliveryTypeMenuProps): JSX.Element | null {
    const {t} = useTranslation('branding');

    if(!isVisible || isMobile) {
        return null;
    }

    // Filter delivery types based on what's allowed for the current message type
    const filteredDeliveryTypes = Object.entries(deliveryTypeIcons).filter(([dType]) => 
        allowedDeliveryTypes.includes(dType as 'email' | 'sms' | 'whatsapp')
    );

    return (
        <>
            {filteredDeliveryTypes.map(([dType, bIcon]) =>
                renderMenuItem(dType, bIcon, selectedDeliveryType, onSelect, t, disabledDeliveryTypes)
            )}
        </>
    );
}

export default DeliveryTypeMenu;